import React from "react";

import {
  Box,
  Chip,
  Typography,
} from "@mui/material";

import AppDataTable from "../../../../components/common/AppDataTable";
import { AnalyticsPanel } from "./AnalyticsVisuals";

import {
  TopMovingPart,
} from "../types";

interface TopMovingPartsTableProps {
  rows: TopMovingPart[];

  loading?: boolean;
}

const TopMovingPartsTable: React.FC<
  TopMovingPartsTableProps
> = ({
  rows,
  loading = false,
}) => {
  const columns = [
    {
      field: "partCode",
      headerName: "Part Code",
      flex: 1,
    },
    {
      field: "partName",
      headerName: "Part Name",
      flex: 2,
    },
    {
      field: "issuedQuantity",
      headerName: "Issued Qty",
      flex: 1,
      renderCell: ({ row }: any) => (
        <Typography
          fontWeight={600}
        >
          {row.issuedQuantity}
        </Typography>
      ),
    },
    {
      field: "availableQuantity",
      headerName: "Available Qty",
      flex: 1,
      renderCell: ({ row }: any) => (
        <Typography>
          {row.availableQuantity}
        </Typography>
      ),
    },
    {
      field: "stockStatus",
      headerName: "Stock Status",
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        const outOfStock = row.availableQuantity === 0;
        const lowStock =
          !outOfStock && row.availableQuantity <= row.reorderLevel;

        return (
          <Chip
            label={
              outOfStock
                ? "Out of Stock"
                : lowStock
                  ? "Low Stock"
                  : "Available"
            }
            color={
              outOfStock
                ? "error"
                : lowStock
                  ? "warning"
                  : "success"
            }
            size="small"
          />
        );
      },
    },
  ];

  return (
    <AnalyticsPanel title="Top Moving Spare Parts">
    <Box sx={{ width: "100%", minWidth: 0, "& > .MuiBox-root": { height: "auto" }, "& .MuiDataGrid-root": { fontSize: ".73rem" }, "& .MuiDataGrid-cell .MuiTypography-root": { fontSize: ".73rem" } }}>

      <AppDataTable
        rows={rows}
        columns={columns}
        loading={loading}
        getRowId={(row) => row.id}
        autoHeight
        disableRowSelectionOnClick
      />
    </Box>
    </AnalyticsPanel>
  );
};

export default TopMovingPartsTable;
